"use client";
import { useState } from "react";

// Module scope and exported so pages/products/revinu can emit FAQPage schema from the same copy.
export const faqs = [
  {
    question: "Does Revinu replace our billing system?",
    answer:
      "No. Revinu works alongside your existing billing stack and enhances payment recovery without replacing your system.",
  },
  {
    question: "Which payment gateways are supported?",
    answer:
      "Revinu supports major gateways including Stripe, Razorpay, PayPal, Adyen, and custom integrations.",
  },
  {
    question: "Can we customize retry logic?",
    answer:
      "Yes. Retry workflows can be customized based on failure type, customer segment, and business rules.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState(null);

  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-20">
      <div className="max-w-3xl mx-auto flex flex-col gap-16">

        {/* Heading */}
        <h2 className="text-4xl font-bold text-center text-gray-900">
          Frequently Asked Questions
        </h2>

        {/* FAQ List */}
        <div className="flex flex-col gap-4">

          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-2xl shadow-sm"
            >
              {/* Question */}
              <button
                onClick={() =>
                  setOpen(open === index ? null : index)
                }
                className="w-full flex justify-between items-center p-8 text-left"
              >
                <span className="text-lg font-bold text-gray-900">
                  {faq.question}
                </span>

                <svg
                  className={`w-6 h-6 text-gray-500 transition-transform ${
                    open === index ? "rotate-180" : ""
                  }`}
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>

              {/* Answer */}
              {open === index && (
                <div className="px-8 pb-8 text-gray-600 leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}

        </div>
      </div>
    </section>
  );
}